import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { subcontractorOverviewService } from '@services/subcontractor/subcontractor';
import { SubcontractorOverview } from '@models/subcontractor.model';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

export const SUBCONTRACTOR_OVERVIEW_QUERY_KEY = 'subcontractorOverview';

// Sprint 25, story-134. One round trip for header + totals + projects/tasks + exceptions +
// materials/equipment roll-up. `useTasksByOriginalOrganizationId`'s loading-flag-only call
// (previously in useSubcontractorData.ts) is replaced by this hook's own `isLoading`.
export const useSubcontractorOverview = (
  subOrganizationId: string | null,
  projectIds?: string[],
): UseQueryResult<SubcontractorOverview, Error> => {
  const { organizationId } = useAppSelector((state: RootState) => state.organization);

  return useQuery({
    queryKey: [SUBCONTRACTOR_OVERVIEW_QUERY_KEY, organizationId, subOrganizationId, projectIds || []],
    queryFn: () => subcontractorOverviewService.getOverview(subOrganizationId as string, projectIds),
    enabled: !!organizationId && !!subOrganizationId,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};

export default useSubcontractorOverview;
